import { useContext, useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { AuthContext } from "../services/contexts/AuthContext";
import firebase from "./firebase";
import "../styles/orders.css";

const STATUS_LABELS = {
  pending: "Изчаква потвърждение",
  processing: "Обработва се",
  shipped: "Изпратена",
  completed: "Завършена",
  cancelled: "Отменена",
};

const formatDate = (ts) => {
  if (!ts) return "—";
  const d = ts.toDate ? ts.toDate() : new Date(ts);
  return d.toLocaleDateString("bg-BG", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
};

export const MyOrders = () => {
  const { user, authLoading } = useContext(AuthContext);
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedId, setExpandedId] = useState(null);

  useEffect(() => {
    if (authLoading) return;
    if (!user) { navigate("/login"); return; }

    const db = firebase.firestore();
    db.collection("Orders")
      .where("userEmail", "==", user.email)
      .get()
      .then((snap) => {
        const data = [];
        snap.forEach((doc) => data.push({ id: doc.id, ...doc.data() }));
        data.sort((a, b) => {
          const aTime = a.createdAt?.toDate?.() || new Date(0);
          const bTime = b.createdAt?.toDate?.() || new Date(0);
          return bTime - aTime;
        });
        setOrders(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching orders:", err);
        setLoading(false);
      });
  }, [user, authLoading, navigate]);

  if (loading) return <div className="orders-page"><p>Зареждане...</p></div>;

  return (
    <div className="orders-page">
      <h2>Моите поръчки</h2>
      <p className="orders-subtitle">{orders.length} поръчки общо</p>

      {orders.length === 0 ? (
        <div className="orders-empty">
          <p>Все още нямате поръчки.</p>
          <Link to="/catalog" style={{ color: "#4CAF50", fontWeight: 600 }}>Разгледай каталога</Link>
        </div>
      ) : (
        <div className="orders-list">
          {orders.map((order) => {
            const isOpen = expandedId === order.id;
            const customer = order.customerInfo || {};

            return (
              <div key={order.id} className="order-card">
                <div className="order-card-header" onClick={() => setExpandedId(isOpen ? null : order.id)}>
                  <div>
                    <div className="order-id">#{order.id.slice(0, 8).toUpperCase()}</div>
                    <div className="order-customer">{customer.name || user.email}</div>
                  </div>
                  <div className="order-date">{formatDate(order.createdAt)}</div>
                  <span className={`status-badge status-${order.status}`}>
                    {STATUS_LABELS[order.status] || order.status}
                  </span>
                  <div className="order-total">{(order.total || 0).toFixed(2)} €</div>
                </div>

                {isOpen && (
                  <div className="order-card-body">
                    {/* Delivery info */}
                    <div>
                      <div className="order-section-title">Доставка</div>
                      <div className="order-info-row">
                        <span className="order-info-label">Начин:</span>
                        <span className="order-info-value">{customer.deliveryMethod || "—"}</span>
                      </div>
                      {customer.city && (
                        <div className="order-info-row">
                          <span className="order-info-label">Град:</span>
                          <span className="order-info-value">{customer.city}</span>
                        </div>
                      )}
                      {customer.address && (
                        <div className="order-info-row">
                          <span className="order-info-label">Адрес:</span>
                          <span className="order-info-value">{customer.address}</span>
                        </div>
                      )}
                    </div>

                    {/* Status info */}
                    <div>
                      <div className="order-section-title">Статус</div>
                      <div style={{ marginBottom: 8 }}>
                        <span className={`status-badge status-${order.status}`}>
                          {STATUS_LABELS[order.status] || order.status}
                        </span>
                      </div>
                      <div className="order-info-row">
                        <span className="order-info-label" style={{ color: "#555", fontSize: 13 }}>
                          При въпроси пишете на stamsy.art@abv.bg
                        </span>
                      </div>
                    </div>

                    {/* Items */}
                    <div className="order-items-section">
                      <div className="order-section-title">Продукти</div>
                      {(order.items || []).map((item, i) => (
                        <div key={i} className="order-item-row">
                          <img
                            src={item.img || ""}
                            alt={item.name}
                            className="order-item-img"
                            onError={(e) => { e.target.style.display = "none"; e.target.nextSibling.style.display = "flex"; }}
                          />
                          <div className="order-item-img" style={{ display: "none", alignItems: "center", justifyContent: "center", background: "#f5f5f5", color: "#ccc", fontSize: 20 }}>🖼</div>
                          <div style={{ flex: 1 }}>
                            <div className="order-item-name">{item.name}</div>
                            <div className="order-item-meta">
                              {item.catalogNumber && <>Кат. №: {item.catalogNumber} · </>}
                              {item.selectedSize && <>Размер: {item.selectedSize} · </>}
                              Бр.: {item.quantity}
                            </div>
                          </div>
                          <div className="order-item-price">
                            {((item.price || 0) * (item.quantity || 1)).toFixed(2)} €
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
